export enum QueryKey {
  ApbPractices = 'apb-practices',
  ApbProcessedEmails = 'apb-processed-emails',
  CaseEvents = 'case-events',
  Cases = 'cases',
  Courts = 'courts',
  DeadlineBadges = 'deadline-badges',
  Deadlines = 'deadlines',
  DeadlineTypes = 'deadline-types',
  EmailCampaignAddresses = 'email-campaign-addresses',
  EmailCampaigns = 'email-campaigns',
  FeatureFlags = 'feature-flags',
  Health = 'health',
  LegalNature = 'legal-natures',
  MassiveEmailReceivers = 'massive-email-receivers',
  MassiveEmailResponses = 'massive-email-responses',
  MassiveEmails = 'massive-emails',
  MassiveEmailTypes = 'massive-email-types',
  MassiveImports = 'massive-imports',
  MassiveImportTypes = 'massive-import-types',
  Me = 'me',
  PctDepositInstances = 'pct-deposit-instances',
  PctDeposits = 'pct-deposits',
  PctDepositTypes = 'pct-deposit-types',
  PctEvents = 'pct-events',
  PctSubjects = 'pct-subjects',
  Permissions = 'permissions',
  Persons = 'persons',
  Portfolios = 'portfolios',
  PracticeEvents = 'practice-events',
  PracticePhases = 'practice-phases',
  Practices = 'practices',
  PracticeTypes = 'practice-types',
  Preview = 'preview',
  Records = 'records',
  RecordTools = 'record-tools',
  RecordTypes = 'record-types',
  Reports = 'reports',
  ReportTypes = 'report-types',
  Roles = 'roles',
  RunnableTools = 'runnable-tools',
  Settings = 'settings',
  Snapshots = 'snapshots',
  Stats = 'stats',
  Storage = 'storage',
  Subjects = 'subjects',
  SubjectTypes = 'subject-types',
  Tasks = 'tasks',
  TaskTypes = 'task-types',
  Templates = 'templates',
  ToolRuns = 'tool-runs',
  Users = 'users',
}
